module.exports = __webpack_public_path__ + "media/PAG88-02.5c65c18b.mp3";